import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    style: style
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M9.08922 11.1176L14.5203 5.6866L13.8132 4.97949L8.49997 10.2926L3.18685 4.97949L2.47974 5.6866L7.91071 11.1176C8.23615 11.443 8.76378 11.443 9.08922 11.1176Z",
    fill: "black",
    fillOpacity: "0.65"
  }));
};
export default SVGComponent;